import { useState, useEffect } from "react";
import { getPositions } from "../api/position/positionUpdateApi";
import { errorStatusHandle } from "../utils/error-utils";
import { getBaseUrl, formatPositionData } from "../services/PositionServices";
import { useDispatch } from "react-redux";
import { clearComponentLoading, setComponentLoading } from "../store/actions";

const useGetPositions = (reload) => {
  const [positions, setPositions] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [sort, setSort] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setComponentLoading("position_update"));
    getPositions(getBaseUrl(page, perPage, sort))
      .then((response) => {
        setPositions(formatPositionData(response.data.positions));
        setTotalCount(response.data.pagination.total_count);
        setTotalPages(response.data.pagination.total_pages);
      })
      .catch((error) => {
        errorStatusHandle(error);
      })
      .finally(() => {
        dispatch(clearComponentLoading("position_update"));
      });
  }, [page, perPage, sort, reload]);

  return {
    positions,
    page,
    perPage,
    totalCount,
    totalPages,
    sort,
    setPositions,
    setPage,
    setPerPage,
    setTotalCount,
    setTotalPages,
    setSort,
  };
};

export default useGetPositions;
